import type { CityConfig } from "@/pages/city-template/types";

export const westBabylonConfig: CityConfig = {
  city: "West Babylon",
  state: "New York",
  stateAbbr: "NY",
  slug: "west-babylon",
  route: "/cities/west-babylon",
  title: "Emergency & Expedited Passport West Babylon NY | Suffolk County",
  metaDescription:
    "Emergency passport West Babylon NY — same day, 24-hour, and 3-5 day expedited passport processing for West Babylon and South Shore Suffolk County. Fast Passport Center serves Lindenhurst, North Babylon, Babylon, and Amityville.",
  h1: "Emergency & Expedited Passport Services in West Babylon, NY",
  heroSubtitle:
    "West Babylon's fast passport solution for South Shore Suffolk County travelers. Whether you're flying out of Long Island MacArthur, JFK, or LaGuardia, Fast Passport Center delivers emergency passports in as little as 24 hours and expedited processing in 3-5 days.",
  heroImageUrl:
    "https://readdy.ai/api/search-image?query=West%20Babylon%20Long%20Island%20New%20York%20suburban%20scene%20at%20golden%20hour%20with%20South%20Shore%20residential%20neighborhood%2C%20classic%20split-level%20homes%20and%20ranch%20houses%2C%20tree-lined%20streets%20with%20American%20flags%2C%20Babylon%20town%20park%20area%2C%20warm%20amber%20afternoon%20light%2C%20modern%20travel%20photography%20with%20clean%20composition%2C%20no%20text%20overlay%2C%20scenic%20Suffolk%20County%20Long%20Island%20New%20York%20suburban%20community%20scene&width=1600&height=700&seq=ny-west-babylon-hero-001&orientation=landscape",
  heroImageAlt: "West Babylon New York suburban neighborhood with South Shore homes at golden hour",
  geoPosition: "40.7182; -73.3543",
  geoPlacename: "West Babylon, New York, United States",
  lastModified: "2026-05-31",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~35 miles (via LIRR or Southern State Parkway)",
  },
  nearbyCitiesZips: [
    { name: "West Babylon", zips: "11704, 11707" },
    { name: "North Babylon", zips: "11703" },
    { name: "Babylon", zips: "11702" },
    { name: "Lindenhurst", zips: "11757" },
    { name: "Amityville", zips: "11701, 11702, 11708, 11726" },
    { name: "Copiague", zips: "11726, 11757" },
    { name: "Deer Park", zips: "11729" },
    { name: "Dix Hills", zips: "11746" },
    { name: "Wyandanch", zips: "11798" },
    { name: "Wheatley Heights", zips: "11798" },
    { name: "Islip", zips: "11751, 11752" },
    { name: "Islip Terrace", zips: "11752" },
    { name: "East Islip", zips: "11730" },
    { name: "West Islip", zips: "11795" },
    { name: "Central Islip", zips: "11722" },
    { name: "Bay Shore", zips: "11706, 11769" },
    { name: "Brentwood", zips: "11717" },
    { name: "Commack", zips: "11725" },
    { name: "Smithtown", zips: "11745, 11754, 11780, 11787, 11788" },
    { name: "Huntington", zips: "11743, 11721, 11740, 11746, 11747, 11750" },
    { name: "Hicksville", zips: "11801, 11802, 11815, 11819, 11854, 11855" },
    { name: "Levittown", zips: "11756, 11714" },
    { name: "Massapequa", zips: "11758, 11762" },
    { name: "Wantagh", zips: "11793" },
    { name: "Seaford", zips: "11783" },
    { name: "Bellmore", zips: "11710" },
    { name: "Merrick", zips: "11566" },
    { name: "Freeport", zips: "11520" },
    { name: "Baldwin", zips: "11510" },
    { name: "East Meadow", zips: "11554" },
    { name: "Uniondale", zips: "11553, 11555, 11556" },
    { name: "Hempstead", zips: "11550, 11551, 11552, 11553, 11554, 11555, 11556, 11557" },
    { name: "Long Island", zips: "11001-11980" },
    { name: "New York City", zips: "10001-10282" },
    { name: "Brooklyn", zips: "11201-11256" },
    { name: "Queens", zips: "11001-11697" },
    { name: "Jamaica", zips: "11430, 11432, 11433, 11434, 11435, 11436" },
    { name: "Stamford", zips: "06901-06907" },
    { name: "Bridgeport", zips: "06601-06608" },
    { name: "Norwalk", zips: "06850-06860" },
  ],
  benefits: [
    {
      icon: "ri-time-line",
      title: "As Fast as 24 Hours",
      desc: "Emergency passport processing for West Babylon travelers with urgent departures — same day service available for documented emergencies.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Registered Courier",
      desc: "U.S. Department of State registered passport courier with direct access to the New York Passport Agency.",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "Real Human Support",
      desc: "Dedicated agents guide you through every step — no chatbots, no automated runaround. Available for West Babylon residents 7 days a week.",
    },
    {
      icon: "ri-map-pin-line",
      title: "South Shore Suffolk County",
      desc: "West Babylon, Lindenhurst, North Babylon, Babylon, and all of South Shore Suffolk County — we serve the entire West Babylon area.",
    },
  ],
  testimonials: [
    {
      name: "Nicole S.",
      location: "West Babylon, NY",
      rating: 5,
      text: "Flying to Puerto Rico for a family wedding in 4 days. Fast Passport Center got my expedited passport processed in 3 days. They helped me find the closest photo center near the West Babylon Walgreens.",
      service: "Expedited Passport",
    },
    {
      name: "Robert F.",
      location: "Lindenhurst, NY",
      rating: 5,
      text: "Renewed my expired passport for a golf trip to Ireland. Chose the 5-day option and had it back in 4. The agent reviewed my documents and made sure everything was perfect before submission.",
      service: "Passport Renewal",
    },
    {
      name: "Donna L.",
      location: "North Babylon, NY",
      rating: 5,
      text: "First-time passport for my daughter's spring break in Cancun. The agent walked us through the acceptance clerk process at the Bay Shore Post Office. Processed in 5 days.",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "west-babylon-1",
      name: "Bay Shore Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "1 Union Boulevard",
      city: "Bay Shore",
      state: "NY",
      zip: "11706",
      phone: "631-665-2200",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "~4 miles from West Babylon",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major passport acceptance facility serving South Shore Suffolk County including West Babylon, Bay Shore, Islip, and Brentwood.",
      icon: "ri-building-2-line",
    },
    {
      id: "west-babylon-2",
      name: "Islip Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "130 Main Street",
      city: "Islip",
      state: "NY",
      zip: "11751",
      phone: "631-277-5255",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "~6 miles from West Babylon",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available by appointment. Convenient for West Babylon, Islip, Bay Shore, and Brentwood residents.",
      icon: "ri-building-2-line",
    },
    {
      id: "west-babylon-3",
      name: "Hicksville Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "17 West John Street",
      city: "Hicksville",
      state: "NY",
      zip: "11801",
      phone: "516-433-2222",
      hours: "Mon-Fri 8:00 AM - 5:00 PM, Sat 9:00 AM - 1:00 PM",
      distance: "~12 miles from West Babylon",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major Nassau County passport acceptance facility. Option for West Babylon residents near the Nassau County border.",
      icon: "ri-building-2-line",
    },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in West Babylon?",
      a: "Fast Passport Center offers same-day emergency passport processing in as little as 24 hours for West Babylon residents with documented life-or-death emergencies. For urgent travel within 2 weeks, our 3-5 day expedited service is the most popular option. Standard processing through the post office takes 8-11 weeks.",
    },
    {
      q: "Where is the closest passport acceptance facility in West Babylon?",
      a: "The Bay Shore Post Office at 1 Union Boulevard is approximately 4 miles from West Babylon and serves as a major South Shore Suffolk County passport acceptance facility. The Islip Post Office at 130 Main Street is about 6 miles away. First-time applicants and those not eligible for mail-in renewal must apply in person.",
    },
    {
      q: "Can I get same-day passport photos in West Babylon?",
      a: "Yes — passport photos are available at CVS Pharmacy, Walgreens, UPS Store, and FedEx Office locations throughout West Babylon, Lindenhurst, North Babylon, and Bay Shore. We also offer photo review as part of our service to ensure your 2x2 photos meet all State Department requirements.",
    },
    {
      q: "How much does an expedited passport cost in West Babylon?",
      a: "Government fees are set by the State Department and vary based on passport type (book vs card, large book option). Fast Passport Center's service fees depend on processing speed: 10-day Smart Saver, 3-5 day Expedited, or 24-hour Emergency. Call 877-253-0084 for a personalized quote based on your West Babylon passport needs.",
    },
    {
      q: "Do I need to visit the New York Passport Agency in person?",
      a: "No — if you use Fast Passport Center, you do not need to visit the New York Passport Agency in Manhattan. As a registered courier, we handle the agency submission for you. West Babylon residents can simply ship documents via overnight courier. The only reason to visit the agency directly is for a documented life-or-death emergency, and appointments are extremely difficult to obtain.",
    },
    {
      q: "What is the fastest way to renew a passport in West Babylon?",
      a: "The fastest way to renew a passport in West Babylon is through Fast Passport Center's 3-5 day expedited service. If your most recent passport was issued when you were 16 or older, within the last 15 years, and is undamaged, you may qualify for renewal without an acceptance clerk visit. For even faster renewal, our 24-hour emergency service is available.",
    },
    {
      q: "Can I get a child passport expedited in West Babylon?",
      a: "Yes — Fast Passport Center expedites child passports for minors under 16 in West Babylon and all of South Shore Suffolk County. Both parents must appear with the child or provide notarized consent (Form DS-3053). We review all parental consent documentation before submission to avoid delays.",
    },
    {
      q: "Does Fast Passport Center have an office in West Babylon?",
      a: "Fast Passport Center operates as a remote courier service — we do not have a physical office in West Babylon. We serve West Babylon and South Shore Suffolk County through our secure overnight shipping and agency submission process. Our headquarters are in Washington, DC.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — West Babylon", address: "various CVS locations in West Babylon, Lindenhurst, North Babylon, and Bay Shore", hours: "Mon-Sun, hours vary by location" },
    { name: "Walgreens — West Babylon Area", address: "various Walgreens locations throughout West Babylon, Lindenhurst, and Amityville", hours: "Mon-Sun, hours vary by location" },
    { name: "UPS Store — West Babylon", address: "various UPS Store locations in West Babylon and surrounding South Shore communities", hours: "Mon-Fri 9:00 AM - 7:00 PM, Sat 10:00 AM - 4:00 PM" },
    { name: "FedEx Office — West Babylon", address: "various FedEx Office locations near West Babylon and Bay Shore", hours: "Mon-Fri 8:00 AM - 9:00 PM, Sat-Sun 10:00 AM - 6:00 PM" },
    { name: "Walmart Photo Center — West Babylon", address: "Walmart locations near West Babylon and Lindenhurst", hours: "Mon-Sun 8:00 AM - 10:00 PM" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Medford",
      address: "2699 Route 112, Medford, NY 11763",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Suffolk County DMV office serving South Shore communities including West Babylon, Lindenhurst, Bay Shore, and Medford. Appointments strongly recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Hempstead",
      address: "50 Clinton Street, Hempstead, NY 11550",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Major Nassau County DMV office for license renewals and REAL ID applications. Convenient for West Babylon residents near the Nassau County border.",
      featured: false,
    },
    {
      name: "NYS DMV — Huntington",
      address: "200 East Main Street, Huntington, NY 11743",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Suffolk County DMV office serving North Shore communities. Alternative option for West Babylon residents.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "ISP",
      name: "Long Island MacArthur Airport",
      distance: "~10 miles from West Babylon",
      address: "100 Arrival Avenue, Ronkonkoma, NY 11779",
      note: "Long Island's own airport with flights to Florida, the Caribbean, and major U.S. hubs. Perfect for West Babylon and South Shore Suffolk County travelers.",
      flightUrl: "https://www.macarthurairport.com/",
      flightLabel: "MacArthur Airport",
      featured: true,
    },
    {
      code: "JFK",
      name: "John F. Kennedy International Airport",
      distance: "~30 miles from West Babylon",
      address: "JFK Access Road, Jamaica, NY 11430",
      note: "Major international gateway with direct flights to Europe, Asia, and worldwide destinations. Accessible via LIRR or Southern State Parkway from West Babylon.",
      flightUrl: "https://www.jfkairport.com/",
      flightLabel: "JFK Airport",
      featured: true,
    },
    {
      code: "LGA",
      name: "LaGuardia Airport",
      distance: "~35 miles from West Babylon",
      address: "Ditmars Boulevard, Flushing, NY 11369",
      note: "Domestic-focused airport with flights to major U.S. cities. Accessible via LIRR or car from West Babylon.",
      flightUrl: "https://www.laguardiaairport.com/",
      flightLabel: "LaGuardia Airport",
      featured: true,
    },
  ],
  services: [
    {
      icon: "ri-passport-line",
      title: "Emergency Passport",
      description: "For West Babylon travelers with urgent departures within 24 hours to 2 weeks. Direct New York Passport Agency submission with dedicated courier handling.",
      bullets: ["Processing as fast as 24 hours", "Dedicated agent assigned to your case", "Daily status updates"],
      badge: "Fastest",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Fast renewal for West Babylon residents with a valid passport issued within the last 15 years at age 16 or older.",
      bullets: ["3-5 day or 10-day options available", "No acceptance clerk visit required", "Secure overnight document return"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-user-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for West Babylon residents with step-by-step guidance through the acceptance clerk process.",
      bullets: ["Complete application review before submission", "Acceptance clerk appointment guidance", "3-5 day or 10-day processing options"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alarm-warning-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement service for West Babylon residents who have lost their passport or had it stolen.",
      bullets: ["DS-64 form guidance included", "Replacement in 3-5 days or 10 days", "Acceptance clerk visit required"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 in West Babylon, with parental consent guidance and acceptance clerk support.",
      bullets: ["Parental consent documentation review", "Both parents present or notarized consent", "3-5 day or 10-day processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal name change for West Babylon residents.",
      bullets: ["Marriage certificate or court order review", "Name change in 3-5 days or 10 days", "No clerk visit for most renewals"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for West Babylon travelers with immediate departure needs from Long Island MacArthur, JFK, or LaGuardia Airport." },
    { name: "Passport Renewal", description: "Fast passport renewal for West Babylon residents with a recent valid passport." },
    { name: "New Passport", description: "First-time passport application assistance for West Babylon residents." },
    { name: "Lost or Stolen Passport", description: "Passport replacement for West Babylon residents who have lost their passport." },
    { name: "Child Passport", description: "Passport services for minors under 16 in West Babylon and South Shore Suffolk County." },
    { name: "Name Change", description: "Passport name change service after marriage, divorce, or legal name change in West Babylon." },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Photos must be 2\"x2\" with a plain white or off-white background. Many West Babylon travelers get rejected at the acceptance clerk because their photos don't meet strict State Department specs.",
    },
    {
      icon: "ri-file-list-3-line",
      title: "Missing or Incorrect Forms",
      description: "Using the wrong form (DS-11 vs DS-82) or missing required fields can cause weeks of delays. We review every form before submission.",
    },
    {
      icon: "ri-calendar-line",
      title: "Waiting Too Long to Start",
      description: "Standard processing takes 8-11 weeks. Many West Babylon travelers wait until the last minute, leaving no buffer for problems.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Incorrect Payment Amount",
      description: "Government fees change frequently. Using an outdated check or wrong amount will cause your application to be returned.",
    },
    {
      icon: "ri-shield-line",
      title: "Damaged or Expired ID",
      description: "Your driver's license or state ID must be valid and unexpired. Many applicants don't realize their ID is about to expire until it's too late.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For child passports, both parents must appear or provide notarized consent. Missing documentation is the #1 reason child applications are delayed.",
    },
  ],
  steps: [
    {
      number: "01",
      icon: "ri-file-list-3-line",
      title: "Complete Your Application",
      description: "Fill out your passport application online or over the phone with our West Babylon team. We review everything for accuracy.",
    },
    {
      number: "02",
      icon: "ri-upload-cloud-line",
      title: "Send Us Your Documents",
      description: "Ship your documents via overnight courier from West Babylon to our secure processing center. We confirm receipt and begin review immediately.",
    },
    {
      number: "03",
      icon: "ri-search-line",
      title: "We Review Everything",
      description: "Our agents verify your forms, photos, and supporting documents meet all State Department requirements — no surprises.",
    },
    {
      number: "04",
      icon: "ri-shield-check-line",
      title: "Courier Submission",
      description: "As a registered U.S. Department of State courier, we submit your application directly to the New York Passport Agency.",
    },
    {
      number: "05",
      icon: "ri-passport-line",
      title: "Receive Your Passport",
      description: "Your passport is delivered securely to your West Babylon address. We provide tracking and daily status updates throughout.",
    },
  ],
  processingOptions: [
    {
      speed: "8-11",
      unit: "weeks",
      label: "Standard Processing",
      tag: "Post Office",
      tagColor: "bg-gray-200 text-gray-600",
      features: [
        "Mail-in application",
        "No expedited handling",
        "No dedicated agent",
        "No phone or email contact for your case",
        "Updates only by physical mail letter",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "10",
      unit: "business days",
      label: "Smart Saver",
      tag: "Fast Passport Center",
      tagColor: "bg-green-100 text-green-700",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned",
        "Daily status updates",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "3-5",
      unit: "business days",
      label: "Expedited Processing",
      tag: "Recommended",
      tagColor: "bg-[#1A365D] text-white",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "24",
      unit: "hours",
      label: "Emergency Processing",
      tag: "Life or Death",
      tagColor: "bg-red-100 text-red-600",
      features: [
        "For documented life-or-death emergencies only",
        "Requires proof of emergency travel",
        "Strictly for documented life-or-death emergencies",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Must book weeks in advance", fpc: "No appointment needed — we handle agency access" },
    { feature: "Processing Speed", agency: "1-2 business days (if you get an appointment)", fpc: "As fast as 3-5 days or 24 hours for emergencies" },
    { feature: "Document Review", agency: "No pre-check — one mistake means restart", fpc: "Complete review before submission — we catch errors" },
    { feature: "Travel Proof", agency: "Requires printed itinerary with confirmed travel within 2 weeks", fpc: "Flexible documentation requirements" },
    { feature: "Updates", agency: "No phone or email support — only mail updates", fpc: "Daily status updates via phone and email" },
    { feature: "Guarantee", agency: "No guarantee of appointment or same-day processing", fpc: "Reserved agency slots with predictable processing" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "New York City", route: "/cities/new-york-city" },
    { name: "Brooklyn", route: "/cities/brooklyn" },
    { name: "Queens", route: "/cities/queens" },
    { name: "The Bronx", route: "/cities/the-bronx" },
    { name: "Staten Island", route: "/cities/staten-island" },
    { name: "Long Island", route: "/cities/long-island" },
    { name: "Bay Shore", route: "/cities/bay-shore" },
    { name: "Commack", route: "/cities/commack" },
    { name: "Hicksville", route: "/cities/hicksville" },
    { name: "Huntington", route: "/cities/huntington" },
    { name: "Islip", route: "/cities/islip" },
    { name: "Levittown", route: "/cities/levittown" },
    { name: "Smithtown", route: "/cities/smithtown" },
    { name: "Buffalo", route: "/cities/buffalo" },
    { name: "Albany", route: "/cities/albany-ny" },
    { name: "Rochester", route: "/cities/rochester" },
    { name: "Syracuse", route: "/cities/syracuse" },
    { name: "Yonkers", route: "/cities/yonkers" },
    { name: "New York State", route: "/states/new-york" },
  ],
  fpcOfficeNote:
    "Fast Passport Center serves West Babylon and all of South Shore Suffolk County as a remote courier service. We do not have a physical office in West Babylon, but our secure overnight shipping network ensures your documents reach our processing center quickly and safely.",
  fpcOfficeDistance: "Remote courier service — West Babylon area",
  serviceAreaIntro:
    "Fast Passport Center provides expedited passport services to West Babylon and all of South Shore Suffolk County. From West Babylon to Lindenhurst, from North Babylon to Babylon — we serve the entire South Shore with fast, reliable processing.",
  nearbyCitiesIntro:
    "We proudly serve West Babylon and all surrounding communities across South Shore Suffolk County. Whether you're in Lindenhurst, North Babylon, Babylon, or Amityville, our expedited passport services are available to you.",
  howItWorksIntro:
    "Our West Babylon customers follow a simple, proven process to get their passports fast. No agency visits, no waiting in lines, no guessing.",
  mistakesIntro:
    "These are the most common mistakes West Babylon travelers make when applying for an expedited passport. Avoiding them saves weeks of delays.",
  testimonialsIntro:
    "West Babylon travelers trust Fast Passport Center for their urgent passport needs. Here's what they say about our service.",
  faqIntro:
    "Common questions about emergency and expedited passport services in West Babylon. If you don't see your question here, call us at 877-253-0084.",
  statePageRoute: "/states/new-york",
  statePageName: "New York Passport Services",
};

export default westBabylonConfig;